// i18n area 'apps' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.bg-BG.meta.json.
import type { enUS } from './apps'

export const bgBG: typeof enUS = {

  // Apps wave 1 (Annex R): container podman gestiti — supervisionati dal
  // worker su un nodo dichiarato; immagine = lockfile branch@digest (Annex Q)
  // con policy pinned/tracking; attacco L3 untagged con IP statico.
  apps: {
    title: 'Приложения',
    create: 'Създай приложение',
    createTitle: 'Създаване на приложение',
    editTitle: 'Редактиране на приложението',
    name: 'Име',
    nameHint: 'DNS-1123, уникално в скоупа — неизменимо след създаването.',
    node: 'Възел',
    nodeHint: 'Възелът член, който го обслужва — явно разполагане (планировчикът идва по-късно).',
    image: 'Образ',
    editImageHint: 'Нова референция се разрешава наново чрез картотеката — жестът на пин/връщане назад.',
    imagePolicy: 'Политика',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Дайджестът се мести само по команда.',
    policyTrackingHint: 'Автоматично обновяване, когато опресняване премести бранча.',
    archMovePolicy: 'Cross-arch преместване',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Какво става, ако app-ът бъде преместен на node с друга архитектура: refuse отказва преместването, reresolve пре-резолвира lockfile-а от branch-а на новата arch — съдържанието се променя и отговорът посочва промяната на digest-а.',
    network: 'Мрежа',
    networkHint: 'L3 untagged закачане: логическа мрежа на фабриката (препоръчана — шлюз/DNS от единствения ѝ източник), оверлей или гол хост бридж (непрепоръчително).',
    overlayPrefix: 'оверлей:',
    fabricPrefix: 'фабрика:',
    bridgePrefix: 'хост бридж:',
    ipAssignment: 'Присвояване на IP',
    ipStatic: 'Статично',
    ipAuto: 'Автоматично (IPAM)',
    ipAssignmentHint_static: 'Адреса го давате вие, сега.',
    ipAssignmentHint_auto: 'IPAM избира свободен адрес от запазените за TVirt диапазони на мрежата.',
    bridgeDiscouraged: 'Гол хост бридж — НЕПРЕПОРЪЧИТЕЛНО: TVirt не знае нищо за адресирането му, така че шлюзът и DNS се дават ръчно. Препоръчаният път е логическа мрежа на фабриката.',
    ip: 'IP',
    ipHint: 'Статичен IPv4 вътре в подмрежата на закачането.',
    ipCidrHint: 'Във форма CIDR върху гол бридж (напр. 192.168.1.10/24) — няма откъде да се изведе префиксът.',
    gateway: 'Шлюз',
    gatewayManualHint: 'Ръчен — голият бридж не извежда нищо.',
    dnsServers: 'DNS сървъри',
    dnsManualHint: 'Ръчни, разделени със запетая — поне един.',
    rootKind: 'Root',
    rootEphemeral: 'ефемерен',
    rootPersistent: 'постоянен',
    rootEphemeralHint: 'Пресъздава се от образа при всяко пресъздаване; живее върху клъстерното ефемерно хранилище.',
    rootEphemeralHintNamed: 'Пресъздава се от образа при всяко пресъздаване; живее върху клъстерното ефемерно хранилище ({name}).',
    rootPersistentHint: 'Преживява рестартите; живее върху хранилището, което изберете.',
    rootStorage: 'Хранилище за root',
    editRootStorageHint: 'Root-ът се рендира наново върху новия пул — съществуващите данни НЕ се местят сами.',
    volumes: 'Томове',
    volumeAdd: 'Добави том',
    volumeName: 'Име',
    volumeMountPath: 'Път на монтиране',
    volumeKind: 'Тип',
    volumeStorage: 'Хранилище',
    devices: 'Устройства',
    deviceClassHint: 'Изисква се КЛАС (таг gpu-device или usb-device), никога конкретно устройство: обявеният възел трябва да има такова, маркирано за приложенията. Няколко приложения могат да ползват едно и също устройство — контейнерът го споделя, не го отнема от хоста.',
    deviceSlot: 'Слот',
    deviceTag: 'Таг',
    deviceValue: 'Клас',
    deviceUnresolved: 'в момента нищо не се разрешава',
    noDeviceTags: 'Няма таг от вид gpu-device или usb-device: създайте такъв и го назначете на устройствата, маркирани за приложенията.',
    env: 'Среда',
    envHint: 'По един КЛЮЧ=стойност на ред.',
    secretEnvTitle: 'Секретни променливи',
    secretEnvNotice: 'Секретна стойност никога не се връща от API-то: никой не я прочита повторно, дори този, който я е записал. В чекпойнта пътува запечатана с мастер-паролата, така че възстановяване без мастер-парола ще поиска да я въведете отново.',
    secretEnvPromote: 'Направете секретна една от променливите, записани по-горе:',
    secretEnvAdd: 'Добавяне на секретна променлива',
    secretEnvName: 'Име',
    secretEnvValue: 'Стойност',
    secretEnvKept: 'запазена — оставете празно, за да не я променяте',
    secretEnvWithdrawWarning: 'За да спрете да третирате като секретна променлива, която вече е такава, ѝ запишете нова стойност: самото сваляне на маркера би било начин да се ПРОЧЕТЕ това, което не излиза от хранилището. Премахването ѝ, обратно, я изтрива.',
    secretEnvChip: 'секретно',
    startNow: 'Стартирай веднага (иначе приложението се ражда спряно)',
    deletePersistentIntro: 'Това приложение има постоянни данни — изберете какво да стане с тях:',
    deleteKeepData: 'Запази данните (директориите остават на своите хранилища, осиротели)',
    deletePurgeData: 'Изтрий и данните',
    phase: 'Фаза',
    phase_running: 'В изпълнение',
    phase_stopped: 'Спряно',
    phase_error: 'Грешка',
    phase_unknown: 'Неизвестно',
    desiredState: 'Желано',
    wantedRunning: 'в изпълнение',
    wantedStopped: 'спряно',
    start: 'Стартирай',
    stop: 'Спри',
    restart: 'Рестартирай',
    refreshImage: 'Обнови образа (приеми новия @current)',
    logs: 'Лог',
    logsTitle: 'Лог',
    logsEmpty: 'Няма прихванат изход.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App не работи — shell има нужда от жив контейнер. Логовете му се четат във всяко състояние.',
    shellConnect: 'Свързване',
    shellDisconnect: 'Прекъсване',
    shellExited: 'Сесията приключи с код на изход {code}.',
    shellEndedWithoutStatus: 'Сесията приключи без статус на изход: {reason}',
    shellRevoked: 'Ticket-ът на сесията вече не е валиден — изтече, или входът, който го отвори, беше отменен.',
    shellHint: 'Кликнете в черното поле и пишете: клавишите стигат до контейнера. Ctrl+C и стрелките работят; exit затваря shell-а.',
    shellStatus: {
      connecting: 'Свързване…',
      connected: 'Свързана',
      ended: 'Приключена'
    },
    deleteRunningError: '{name} е желано в изпълнение — първо го спрете.',

    // Dialog standard (round #156): i tab del dettaglio e i campi contract
    // mancanti — ogni campo dell'App visibile, lucchetti col perché.
    tabs: {
      general: 'Общи',
      image: 'Образ',
      network: 'Мрежа',
      storage: 'Хранилище',
      devices: 'Устройства',
      observed: 'Наблюдавано'
    },
    attachment: 'Закачане',
    runningDigest: 'Дайджест в изпълнение',
    lastError: 'Последна грешка',
    reportObservedAt: 'Последен доклад на уъркъра',
    desiredStateLock: 'Управляват го действията Стартирай/Спри — никога директна промяна.',
    ipEditDisabledHint: 'Променя се само при статично присвояване.',
    derivedFromNetworkHint: 'Изведено от единствения източник на мрежата — ръчно само върху гол бридж със статичен IP.',
    ephemeralUnset: 'не е конфигурирано',
    ephemeralMissing: 'Ефемерното хранилище на приложенията не е конфигурирано — създаването на приложение с ефемерни части (root или томове) се отказва, докато не го зададете.',
    ephemeralCurrent: 'Ефемерно хранилище на приложенията: {name}',
    ephemeralMissingCreate: 'Това приложение има ефемерни части, но ефемерното хранилище на приложенията не е зададено — създаването ще бъде отказано. Първо го задайте от банера на страницата Приложения.',
    setEphemeral: 'Задай ефемерно хранилище',
    changeEphemeral: 'Смени ефемерното хранилище',
    setEphemeralTitle: 'Задаване на ефемерното хранилище на приложенията',
    changeEphemeralTitle: 'Смяна на ефемерното хранилище на приложенията',
    ephemeralStorageHint: 'Клъстерно ПОДРАЗБИРАНЕ: dir-подобният пул, където живеят root-овете и ефемерните томове на всяко приложение, освен при декларирано предефиниране от приложението. Смяната не е на горещо и не рестартира нищо: важи от следващия старт на всяко приложение — ефемерните данни не се местят.',
    ephemeralPool: 'Пул на хранилището',
    ephemeralOverride: 'Ефемерно хранилище (предефиниране за приложението)',
    ephemeralOverrideInherit: 'Наследява клъстерното подразбиране',
    ephemeralOverrideInheritNamed: 'Наследява клъстерното подразбиране ({name})',
    ephemeralOverrideHint: 'Пул за root и ефемерните томове на това приложение — оставете празно, за да наследи клъстерното подразбиране. Смяната не е на горещо и не рестартира нищо: важи от следващия старт (ефемерните данни се раждат наново празни на новия пул) и изисква правото app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'предефинирано',

    imageAnyBranch: 'Всички клонове',
    imageBranchHint: 'Стеснява образите до именуваните от този клон; без клон се виждат всички образи на хранилището.',
    imageDigestHint: 'Съдържанието: избира се от таблицата с дайджести, която носи произхода и архитектурата му. Един и същ клон предлага по едно за архитектура и те не са взаимозаменяеми.',
    imageLockfile: 'Разрешена препратка',
    imageNoImages: 'Няма образи в кеша за това хранилище — изтегли един от Образи OCI.',
    imageHeadNotCached: 'не е в кеша — изтегля се при стартиране',
    imageNoRegistries: 'Няма регистрирано хранилище: регистрирай едно, за да можеш да избереш образ.',
    imageChosenHint: 'Образът се избира от каскадата в прозореца за редактиране: препратката никога не се пише на ръка.',
    registerRepositoryHint: 'Регистрирането не изтегля нищо: прави хранилището наблюдаемо, за да може образът да се избере, без да напускаш този прозорец.',
    registerRepositoryBranchHint: 'По желание: първият клон за наблюдение (напр. latest).',
    registerRepositoryElsewhere: 'Търсеното хранилище не е регистрирано: регистрирането става в раздела Образи OCI, от някой с правото за това.'
  },

  // Template CT (round K2 #63): gli oggetti CT MATERIALIZZATI — l'import da
  // catalogo è l'unico ingresso; i file si caricano dentro i cataloghi.
  cts: {
    createAction: 'Създай CT',
    createTitle: 'Създаване на контейнер от шаблон',
    createError: 'Контейнерът не беше създаден',
    template: 'CT шаблон',
    noTemplates: 'Няма CT шаблони — импортирайте един от CT шаблони',
    resources: 'Ресурси',
    node: 'Възел',
    phase: {
      defined: 'Никога не е пускан',
      materializing: 'В материализация',
      ready: 'Готов',
      starting: 'В стартиране',
      running: 'В изпълнение',
      stopping: 'В спиране',
      stopped: 'Спрян',
      deleting: 'В изтриване',
      error: 'В грешка'
    },
    actions: {
      start: 'Стартирай',
      stop: 'Спри',
      restart: 'Рестартирай',
      markTemplate: 'Повиши до CT шаблон',
      error: 'Действието беше отказано'
    },
    markTemplate: {
      confirmTitle: "Да се повиши ли '{name}' до CT шаблон?",
      confirmBody: 'Контейнерът напуска този списък и минава при CT шаблоните, веднага готов да ражда нови CT. Метаданните остават променими и можете да го върнете към CT по всяко време.',
      confirm: 'Повиши',
      moved: "'{name}' вече е CT шаблон — ще го намерите в CT шаблони."
    },
    stopCause: {
      api: 'Спрян от TVirt',
      'ct-exit': 'Контейнерът излезе сам',
      'host-reboot': 'Умря с рестарта на възела',
      'start-failed': 'Стартът се провали — грешката на задачата казва какво липсва и как се оправя'
    },

    console: 'Конзола',
    consoleUnavailable: 'Контейнерът не е в изпълнение — конзолата има нужда от жив контейнер. Логът му обаче се чете във всяко състояние.',
    consoleNoTemplate: 'Шаблонът никога не се изпълнява, затова няма конзола: създайте от него CT и отворете неговата.',
    consoleConnect: 'Свържи се',
    consoleDisconnect: 'Прекъсни връзката',
    consoleReconnect: 'Свържи се отново',
    consoleTakenBy: 'Тази конзола беше поета от друг оператор ({user}). Една конзола на контейнер: повторното свързване си я връща.',
    consoleHint: 'Щракнете върху черното поле и пишете: клавишите стигат до контейнера. Ctrl+C и стрелките работят.',
    consoleEndpointDown: 'Точката за достъп до конзолата не може да се отвори на възела, който обслужва контейнера: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Контейнерът не работи — shell има нужда от жив контейнер. Логовете му се четат във всяко състояние.',
    shellNoTemplate: 'Един template никога не се изпълнява, затова няма shell: създай CT от него и отвори неговия.',
    shellConnect: 'Свързване',
    shellDisconnect: 'Прекъсване',
    shellExited: 'Сесията приключи с код на изход {code}.',
    shellEndedWithoutStatus: 'Сесията приключи без статус на изход: {reason}',
    shellRevoked: 'Ticket-ът на сесията вече не е валиден — изтече, или входът, който го отвори, беше отменен.',
    shellHint: 'Кликнете в черното поле и пишете: клавишите стигат до контейнера. Ctrl+C и стрелките работят; exit затваря shell-а.',
    shellStatus: {
      connecting: 'Свързване…',
      connected: 'Свързана',
      ended: 'Приключена'
    },
    rootPassword: 'Парола на root',
    rootPasswordHint: 'Записва се веднъж в копирания rootfs (като hash, никога повече не се показва). Образите на дистрибуциите нямат парола за root: без нея shell-ът е единственият вход.',
    sshKeys: 'Публични SSH ключове на root',
    sshKeysHint: 'По един публичен OpenSSH ключ на ред, в root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Свързване…',
      connected: 'Свързана',
      reconnecting: 'Повторно свързване…'
    },
    logs: 'Лог',
    logsTitle: 'Лог',
    logsEmpty: 'Няма прихванат изход.',
    logsSource: 'Кой лог',
    logsSourceConsole: 'Конзолата на init на контейнера — защо услугата вътре не тръгна',
    logsSourceSupervisor: 'Надзорникът liblxc — защо контейнерът така и не стигна до изпълнение',
    logsNeverStarted: 'Никога не е бил стартиран, затова още няма нищо записано — стартирайте го и логът ще е там дори ако стартът се провали.',
    logsNoTemplate: 'Шаблонът никога не се изпълнява, затова никога не е записвал нищо.',
    logsError: 'Логът не беше прихванат',

    // Dialog standard (round #156): i tab del dettaglio condivisi dalle
    // liste CT e Template CT, più i lucchetti col perché.
    tabs: {
      general: 'Общи',
      hardware: 'Хардуер',
      network: 'Мрежа',
      provenance: 'Произход'
    },
    templateFlag: 'CT шаблон',
    templateLock: 'Сменя се само с действията Повиши / Върни към CT — никога директна промяна.',
    sourceLock: 'Произход, записан при раждането — никога не се пренаписва; мъртъв източник оставя референцията гола.',
    storageLock: 'Фиксирано при създаването — преместването на rootfs е бъдещ рунд.',
    startedAt: 'Стартиран',
    lastStop: 'Последно спиране',
    editNicsTitle: 'Редактиране на мрежите',
    nicDisconnected: 'разкачена'
  },
  ctTemplates: {
    title: 'CT шаблони',
    importAction: 'Импортирай от каталог',
    importTitle: 'Импортиране на CT шаблон от каталога',
    importSubmit: 'Импортирай',
    importError: 'Импортът беше отказан',
    importHint: 'Материализирането копира rootfs върху избраното хранилище — каталожният файл остава непокътнат. За да добавите нови файлове, първо ги качете в каталог.',
    sourceFile: 'CT шаблонен файл',
    sourceFileHint: 'Файловете ct-rootfs от избрания каталог, само готовите',
    noFiles: 'Няма готов ct-rootfs файл в този каталог — качете един от страницата на каталога',
    source: 'Файл източник',
    rootfsStorage: 'Хранилище на rootfs',
    rootfsStorageHint: "Където живее разархивираното rootfs дърво — хранилище с файлова система и достатъчно свободно място за разархивирания размер плюс около 1 GiB резерв (иначе импортът се проваля).",
    resources: 'Ресурси',
    cores: 'vCPU',
    memoryMiB: 'Памет (MiB)',
    cpuLimit: 'CPU лимит',
    cpuLimitHint: 'Еквиваленти на хост ядра (напр. 1.5); празно = без таван',
    cpuUncapped: 'без таван',
    cpuWeight: 'CPU тегло',
    hostname: 'Име на хоста',
    hostnameHint: 'Празно = името на CT',
    nameservers: 'Nameserver DNS',
    dnsHint: 'Разделени със запетая; празно = наследява тези на хоста',
    searchDomains: 'DNS домейни за търсене',
    dnsInherited: 'Наследено от хоста',
    networks: 'Мрежи',
    nicSlot: 'NIC слот',
    phase: {
      materializing: 'В материализация',
      ready: 'Готов',
      deleting: 'В изтриване',
      error: 'Грешка'
    },
    exportAction: 'Експортирай в каталога',
    exportTitle: 'Експортиране в каталога',
    exportSubmit: 'Експортирай',
    exportError: 'Експортът беше отказан',
    exportHint: 'Пакетира материализираното rootfs в НОВ ct-rootfs файл в избрания каталог — шаблонът остава непокътнат.',
    exportName: 'Име на файла',
    exportNameHint: 'Празно = <шаблон>-export-<n>',
    markCt: {
      action: 'Върни към CT',
      confirmTitle: "Да се върне ли '{name}' към CT?",
      confirmBody: 'Шаблонът напуска този списък и се връща в списъка CT, отново стартируем. Докато не го повишите пак, от него не могат да се създават CT.',
      confirm: 'Върни към CT',
      moved: "'{name}' отново е CT — ще го намерите в списъка CT."
    }
  },

  // OCI wave 1 (Annex Q — il modello tag-come-branch): un tag OCI è un branch
  // (puntatore mobile), il digest è il commit; refresh = "git fetch",
  // pull = risolvi ADESSO, scarica QUEL digest.
  oci: {
    registriesTitle: 'OCI регистри',
    imagesTitle: 'OCI образи',
    provider: 'Доставчик',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Генеричен',
    providerImmutableHint: 'Доставчикът е неизменим след създаването — друг доставчик е нов регистър.',
    url: 'URL',
    urlHintPreset: 'Предварително попълнен от доставчика — презапишете само за огледала.',
    urlHintRequired: 'Задължителен за генеричните регистри: базовият https:// URL.',
    urlHintEcr: 'Задължителен: ECR крайните точки са по акаунт/по регион — няма преднастройка.',
    credential: 'Идентификационни данни',
    credentialNone: 'Анонимен достъп',
    credentialHint: 'Запис в хранилището за ключове от тип потребител-и-парола; уъркърите ги разрешават в момента на употреба — никога auth файл по възел.',
    nameHint: 'Име от вида на хост (docker.io, registry.intra); уникално за скоуп, неизменимо',
    addRegistry: 'Добави регистър',
    addRegistryTitle: 'Добавяне на OCI регистър',
    verify: 'Провери',
    verifyState: 'Проверка',
    verified: 'Проверен',
    verifyFailed: 'Неуспешна',
    neverVerified: 'Никога не е проверяван',
    registryInUseError: "'{name}' още има регистрирани репозитории — първо ги изтрийте.",
    repositories: 'Репозитории',
    repositoriesHint: 'Регистрирането наблюдава бранчовете (OCI тагове) — не изтегля нищо. Опресняването разрешава всеки наблюдаван бранч и поддържа reflog-а.',
    noRepositories: 'Няма регистрирани репозитории в този регистър.',
    registerRepository: 'Регистрирай репозиторий',
    repoPath: 'Път',
    repoPathHint: "Път на репозитория в регистъра, напр. 'example' или 'library/nginx'",
    branches: 'Бранчове',
    branchesHint: 'Наблюдавани бранчове (OCI тагове), разделени със запетая — напр. 1.1.0, 1.1.1',
    branch: 'Бранч',
    branchPullHint: 'Разрешен СЕГА: pull изтегля дайджеста, към който бранчът сочи днес.',
    refresh: 'Опресни',
    deleteRepository: 'Изтрий репозитория',
    reflogCount: '{n} предишни',
    noResolutions: 'Никога не е опресняван — няма наблюдавано разрешаване.',
    refreshFailed: 'Последното опресняване се провали ({when})',
    loadError: 'Неуспешно зареждане на репозиториите.',
    reference: 'Референция',
    digest: 'Дайджест',
    digestHint: 'sha256:… — точният образ, без бранч (detached)',
    size: 'Размер',
    nodes: 'Възли',
    detached: 'detached',
    detachedHint: 'Изтеглен по дайджест, без бранч — контролът за дрифт не се прилага.',
    pulledAt: 'Изтеглен',
    pull: 'Pull',
    pullTitle: 'Pull на образ',
    pullHint: 'Предварително затопляне, никога предпоставка: pull по бранч разрешава СЕГА и изтегля ТОЗИ дайджест; pull по дайджест е detached.',
    pullError: 'Pull беше отказан',
    pullMode: 'Pull по',
    pullModeBranch: 'Бранч (разреши сега)',
    pullModeDigest: 'Дайджест (detached)',
    pullModeBranchHint: 'Честното подразбиране: като apt install, изпълнен по-късно може да даде друг образ.',
    pullModeDigestHint: 'Точен дайджест — възпроизводимост и връщане назад; отказва се от контрола за дрифт.',

    // Il pattern a due pulsanti (#88, ratifica 2026-07-30 sera): "da
    // registry" è il pull guidato esistente, "da catalogo" materializza un
    // archivio oci-image pronto (la via air-gapped).
    importFromRegistry: 'Импортирай от регистър',
    importFromCatalog: 'Импортирай от каталог',
    importCatalogTitle: 'Импортиране на OCI образ от каталог',
    importCatalogHint: 'Air-gapped пътят: готов oci-image архив (tar/tar.gz — docker-archive или oci-archive) се материализира в хранилището за образи с референцията catalog/<каталог>/<файл>@<дайджест>; приложенията го консумират като всеки друг образ. Архивите се качват в каталозите — този раздел само импортира.',
    importCatalogFile: 'Архив',
    importCatalogFileHint: 'Готовите oci-image файлове от избрания каталог.',
    importCatalogNoFiles: 'Няма готов oci-image архив в този каталог — качете един от детайла на каталога.',
    importCatalogError: 'Импортът беше отказан',
    registry: 'Регистър',
    repository: 'Репозиторий',
    cacheMissing: 'Клъстерният OCI кеш не е конфигуриран — pull се отказва, докато не зададете пул на хранилището.',
    setCache: 'Задай кеш',
    setCacheTitle: 'Конфигуриране на OCI кеша',
    setCacheHint: 'Клъстерният пул ПО ПОДРАЗБИРАНЕ, който приютява блобовете на изтеглените образи — един скоуп може да го предефинира със собствен пул (страница Скоупове). Смяната не е на горещо и не рестартира нищо, и не мести блобовете: те се появяват отново при нужда при следващия старт/употреба.',
    cachePool: 'Пул на хранилището',
    changeCache: 'Смени кеша',
    changeCacheTitle: 'Смяна на пула на OCI кеша',
    cacheCurrent: 'OCI кеш на клъстера (по подразбиране): {name}',
    sectionOverview: 'Преглед',
    sectionRepositories: 'Репозитории',
    sectionExplore: 'Разглеждане',
    exploreHint: 'Отдалечено търсене на живо в регистъра — Docker Hub пълно (описание, изтегляния, звезди), другите доставчици — доколкото могат. Изберете резултат, за да прочетете пълното му описание и да разлистите отдалечените му тагове; от таг можете да добавите референцията към TVirt репозиторий.',
    exploreSearch: 'Търси',
    exploreUnsupported: 'Този доставчик не поддържа търсене.',
    exploreNoResult: 'Няма съвпадащ репозиторий.',
    exploreNoTags: 'Няма съвпадащ таг в този репозиторий.',
    exploreOfficial: 'Официален',
    explorePulls: 'Изтегляния',
    exploreStars: 'Звезди',
    exploreUpdated: 'Обновен {when}',
    exploreLoadMore: 'Зареди още',
    exploreSelectHint: 'Изберете резултат: пълното описание и отдалечените тагове се зареждат тук.',
    exploreNoDescription: 'Няма налично описание от този доставчик.',
    exploreTagsTitle: 'Отдалечени тагове',
    exploreTagFilter: 'Търси таг',
    exploreAddToRepo: 'Добави към репозиторий',
    exploreAdded: '{path}:{tag} вече се следи — вижте раздела Репозитории.',
    addBranch: 'Добави бранч',
    purgeRequiredTitle: "Да се изтрие ли '{name}' и образите му?",
    purgeRequiredBody: 'Никое приложение не консумира този репозиторий, но още съществуват изтеглени образи: изтриването му премахва и техните записи, а блобовете в кеша минават към събирача на отпадъци.',
    purgeConfirm: 'Изтрий и образите',
    providerSelectHint: 'Изберете типа регистър: картата разказва преднастройките и употребата.',
    providerDesc: {
      dockerhub: 'Публичният Docker регистър: предварително попълнен URL, пълно търсене с описания и броячи.',
      ghcr: 'GitHub Container Registry: предварително попълнен URL; акаунтите използват персонален токен за достъп.',
      ecr: 'Amazon Elastic Container Registry: крайни точки по акаунт/по регион — URL-ът трябва да се посочи.',
      quay: 'Регистърът Red Hat Quay: предварително попълнен URL.',
      generic: 'Self-hosted регистър (Harbor, registry:2, …): https:// URL-ът е задължителен.'
    },

    // Dialog standard (round #156): i campi del dettaglio immagine/registry
    // che le colonne non mostravano.
    layerCount: 'Слоеве',
    verifiedAt: 'Последна проверка',
    verifyOk: 'Резултат',
    verifyMessage: 'Съобщение от проверката',

    // Моделът #348/R39: образът Е дайджестът — съдържанието — а registry, хранилището и клонът са ИМЕНАТА, които го достигат.
    head: 'Head',
    heads: 'Глави по архитектура',
    listDigest: 'Дайджест на списъка',
    neverResolved: 'Никога не е разрешаван',
    totalSize: 'Общ размер',
    reflogTitle: 'История на разрешаванията',
    usedBy: 'Използван от',
    usageLockfile: 'lockfile',
    usageRunning: 'в изпълнение',
    evictable: 'изхвърляем',
    evict: 'Изхвърли от кеша',
    evictHeadTitle: 'Да се изхвърли ли {digest}?',
    evictHeadBody: 'Това е текущото разрешаване на поне един колектор: изхвърлянето му е легитимно — това е само кеш, отдалеченият бранч още го сервира — но не бива да става по погрешка. Блобът е ЕДИН: изхвърлянето изпразва всички колектори, които го споделят.',
    evictConfirm: 'Изхвърли го въпреки това',

    arch: 'Архитектура',
    names: 'Имена',
    noNames: 'без име',
    views: 'Изгледи',
    lastView: 'последен изглед',
    evictLastViewTitle: 'Да се премахне ли последната препратка към {digest}?',
    evictLastViewBody: 'Това е последният изглед към това съдържание: с премахването му образът престава да съществува в TVirt и байтовете ({size}) се освобождават. Това е docker image rm на модела — не страничен ефект, а самата операция.',
    branchesTabHint: 'Наблюдаваните клонове на това хранилище: за всеки днешните глави — по една за архитектура — хронологията на обновяванията и колко от именуваните от него образи са в кеша. Обновяването е «git fetch» на хранилището: решава всички клонове наведнъж.',
    noBranches: 'В това хранилище не се наблюдава нито един клон.',
    stopObserving: 'Спри наблюдението на клона',
    pullBranch: 'Изтегли в кеша върха на branch-а (refresh-ът разрешава, това изтегля)',
    pullDigest: 'Изтегли в кеша този digest',
    imageCount: 'Образи',
    deleteBranchPurgeTitle: 'Да останат ли образите на {name} без име?',
    deleteBranchPurgeBody: 'Никое приложение не именува този клон, но някои образи се достигат само през него: при изтриването му остават в кеша без име, изброени сред образите на хранилището и премахваеми ръчно.',
    deleteBranchPurgeConfirm: 'Изтрий и остави образите без име',
    imagesTabHint: 'Образите на това хранилище — съдържанията, тоест дайджестите — видими и без избор на клон. Образът е уникален за клъстера: имената, които го достигат, може да са няколко.',
    noImages: 'Нито един образ на това хранилище не е материализиран в кеша.',
    deleteRepositoryTitle: 'Да се изтрие ли {name}?',
    deleteRepositoryBody: 'Хранилището и клоновете му изчезват заедно с хронологията си. Образите остават в кеша: губят само това име. Хранилище, именувано от приложение, не се изтрива.',
    provenanceCatalog: 'каталог',
    refreshedAt: 'Обновено',
    neverRefreshed: 'Никога не е обновявано',
    sectionBranches: 'Клонове',
    sectionImages: 'Образи',
    repositoriesGovernedElsewhere: 'Тук хранилищата само се разглеждат: регистрирането, обновяването, наблюдението на клоновете и премахването на образите става в раздела Образи OCI.',
    gotoImages: 'Към Образи OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Подове',
    containers: 'Контейнери',
    instances: 'Инстанции',
    instancesTooltip: '{running} работещи, {error} с грешка',
    placement: 'Разполагане',
    spread: 'разпределение',
    ha: 'HA',
    templateRevision: 'ревизия',
    deleting: 'Изтрива се',
    empty: 'Няма подове — създайте приложение (един контейнер) или под от CLI (create-pod).',
    openInstances: 'Отвори инстанциите',
    rollingRestart: 'Поетапно рестартиране',
    scale: 'Мащабиране',
    scaleTitle: 'Мащабиране на {name}',
    scaleHint: 'Брой инстанции (0–64): нагоре се запълва най-ниският свободен пореден номер, надолу се оттегля най-високият, а данните му се запазват.',
    scaleError: 'Мащабирането не успя',
    replicas: 'Реплики',
    deleteRunningError: '{name} работи — първо го спрете.',
    deleteInstancesIntro: 'Всички {count} инстанции ще бъдат премахнати.',
    stateRunning: 'Работи',
    stateStopped: 'Спрян',
    editor: {
      createTitle: 'Създай Pod',
      create: 'Създай Pod',
      editTitle: 'Редактирай Pod',
      nameHint: 'DNS-1123, най-много 58 знака — инстанциите се казват <име>-<индекс>; неизменимо след създаването.',
      restartPolicy: 'Политика на рестартиране',
      restartPolicyHint_always: 'Възелът рестартира всеки излязъл контейнер с експоненциално изчакване (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Рестартира се само контейнер, излязъл с ненулев код; изход 0 остава в покой.',
      restartPolicyHint_never: 'Излязъл контейнер остава както е — инстанцията завършва като succeeded или failed.',
      grace: 'Отсрочка (s)',
      graceHint: 'Границата SIGTERM → SIGKILL на спирането.',
      hostname: 'Име на хост',
      hostnameHint: 'Празно = името на инстанцията.',
      hostnameDefault: 'името на инстанцията',
      sharePid: 'Споделяй PID пространството от имена между контейнерите',
      containersIntro: 'Init контейнерите се изпълняват докрай, по ред, преди контейнерите да стартират; контейнерите споделят мрежата на инстанцията (един IP, localhost помежду си).',
      initContainers: 'Init контейнери',
      initAdd: 'Добави init контейнер',
      initHint: 'Всеки трябва да излезе с 0; провал поставя инстанцията в грешка и възелът го повтаря с изчакване.',
      containerAdd: 'Добави контейнер',
      atLeastOne: 'Pod се нуждае от поне един контейнер.',
      duplicateNames: 'Имената на контейнерите трябва да са уникални в Pod (включително init контейнерите).',
      containerName: 'Име на контейнера',
      containerInvalid: 'Този контейнер е непълен: име (DNS-1123), образ, монтирания върху декларирани томове, числови лимити и проба.',
      command: 'Команда',
      commandHint: 'Замества entrypoint на образа — по един аргумент на ред, никога shell низ.',
      args: 'Аргументи',
      argsHint: 'По един на ред (CMD на образа, ако е празно).',
      mounts: 'Монтирания',
      mountAdd: 'Добави монтиране',
      mountNoVolumes: 'Първо декларирайте том в раздела Хранилище.',
      readOnly: 'само за четене',
      resources: 'Лимити',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (напр. 1.5)',
      memory: 'Памет (MiB)',
      memoryHint: 'podman --memory',
      health: 'Проба за жизненост',
      healthCmd: 'Команда на пробата',
      healthCmdHint: 'Изпълнява се в контейнера от възела при всеки надзорен такт — по един аргумент на ред; изход 0 = здрав.',
      healthTimeout: 'Таймаут (s)',
      healthRetries: 'Опити',
      healthRetriesHint: 'Последователни провали, преди възелът да рестартира контейнера.',
      ips: 'Статични адреси',
      ipsHint: 'По един на инстанция, по пореден номер — мащабиране извън списъка се отказва.',
      instance: 'инстанция',
      volumesHint: 'Томовете са на Pod; пътят за монтиране е на всеки контейнер (раздел Контейнери).',
      spread: 'Разпределение',
      spreadHint_preferred: 'Инстанции на различни възли, когато е възможно.',
      spreadHint_required: 'Инстанции на различни възли, иначе мащабирането отказва.',
      spreadHint_none: 'Само решаващият.',
      ha: 'Висока наличност (opt-in)',
      haHint: 'Всяка постоянна част на споделен storage; ако възелът умре, HA decider-ът пресъздава инстанциите на друг член (автоматичен failover, като HA VM).',
      yes: 'да',
      no: 'не'
    },
    detail: {
      container: 'Контейнер',
      actions: 'Действия',
      ready: 'Готов',
      notReady: 'Не е готов',
      restarts: 'Рестарти',
      lastRestartAt: 'Последен рестарт:',
      backoffUntil: 'Нов опит в',
      stateAbsent: 'липсва',
      stateRunning: 'работи',
      stateTerminated: 'приключил',
      stateWaiting: 'изчаква',
      init: 'init',
      noInstances: 'Няма инстанции (реплики 0).',
      ha: 'HA',
      haHint: 'Автоматичен failover: ако възелът умре, HA decider-ът пресъздава инстанцията на друг член (всяка постоянна част на споделен storage).',
      authority: 'Authority (възел)',
      homeless: 'без authority',
      homelessHint: 'Възстановяването от checkpoint оставя authority-то навън (#380): никой възел не я обслужва, докато не мащабирате Pod-а (дори до същия брой реплики).',
      restartContainer: 'Рестартирай само този контейнер (pod остава активен)',
      divergingHint: 'Желаното състояние на тази инстанция се различава от подразбиращото се на Pod (PD-P19).',
      revisionLag: 'ревизия {applied} приложена от {current}',
      updatedInstances: '{updated}/{desired} инстанции на тази ревизия'
    }
  }
}
